export const environment = {
  production: false,
  apiUrl: 'https://apitestbc.azurewebsites.net',
  thisUrl: 'https://testbusinesshub.lsretail.com',
  authenticationServiceUrl: 'https://test-ls-auth-service.azurewebsites.net',
  skipBcJobQueueCheck: true,
  allowBcSuperOrders: true,
  version: '00.11',

  saltpay: {
    paymentApiUrl: 'https://test.borgun.is/SecurePay/default.aspx',
    secureKey: 'cdedfbb6ecab4a4994ac880144dd92dc',
    merchantid: '9256684',
    paymentgatewayid: '471',
    merchantemail: 'yasir.butt@lsretail.com',
  },
  googleAnalyticsId: '',
  azureAdB2C: {
    authority: 'https://lsretailb2c.b2clogin.com/lsretailb2c.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN/v2.0',
    authWellknownEndpointUrl:
      'https://lsretailb2c.b2clogin.com/lsretailb2c.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN/v2.0/.well-known/openid-configuration',
    apiscope: 'https://lsretailb2c.onmicrosoft.com/cfae354a-5d07-4eb9-a1b9-79a013e41275/api',
    clientId: 'cdf872ee-3bce-46e6-ab86-5906576a9318',
    bhclaim: 'Business Hub',
  },
};
